const comments = [
  {
    name: '追剧小达人',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20clean%20minimal%20background%2C%20professional%20headshot%20style%2C%20warm%20neutral%20tones&width=80&height=80&seq=avatar-cmt-01&orientation=squarish',
    time: '2小时前',
    text: '58影院真的太良心了！追了好久的长安风云录全集都有了，画质清晰一点都不卡，周末一口气刷完了整季，太爽了！强烈推荐给身边的朋友们。',
    show: '长安风云录',
  },
  {
    name: '深夜追剧人',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%20with%20gentle%20expression%2C%20soft%20lighting%2C%20clean%20background%2C%20professional%20headshot%20style%2C%20warm%20neutral%20tones&width=80&height=80&seq=avatar-cmt-02&orientation=squarish',
    time: '5小时前',
    text: '不用注册就能直接看全集，这个体验真的绝了。之前在其他平台追剧又是会员又是广告的，58影院直接点开就看，高清而且更新速度还快。',
    show: '遇见你的那天',
  },
  {
    name: '剧荒终结者',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20portrait%20with%20friendly%20smile%2C%20soft%20lighting%2C%20clean%20minimal%20background%2C%20professional%20headshot%20style%2C%20warm%20natural%20tones&width=80&height=80&seq=avatar-cmt-03&orientation=squarish',
    time: '8小时前',
    text: '分类特别全，国产剧、韩剧、美剧都有，而且每天都有新剧更新。我已经把58影院设成浏览器首页了，每天必刷！',
    show: '迷雾追踪',
  },
  {
    name: '追剧老司机',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20portrait%20with%20confident%20expression%2C%20soft%20lighting%2C%20clean%20background%2C%20professional%20headshot%20style%2C%20warm%20natural%20tones&width=80&height=80&seq=avatar-cmt-04&orientation=squarish',
    time: '1天前',
    text: '用了大半年了，58影院的剧集资源确实丰富，很多冷门好剧也都能找到。画质稳定，加载速度快，良心平台值得支持！',
    show: '江湖夜雨',
  },
  {
    name: '剧迷小透明',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20with%20bright%20smile%2C%20soft%20lighting%2C%20clean%20background%2C%20professional%20headshot%20style%2C%20warm%20natural%20tones&width=80&height=80&seq=avatar-cmt-05&orientation=squarish',
    time: '2天前',
    text: '手机端浏览体验也很棒，通勤路上追两集完全没问题。最重要的是完全免费！终于找到一个不用花钱就能安心追剧的好地方了。',
    show: '星光之恋',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">观众热评</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            来自真实追剧用户的使用反馈，听听他们怎么说
          </p>
        </div>

        <div className="max-w-4xl mx-auto space-y-4">
          {comments.map((cmt, idx) => (
            <div
              key={idx}
              className="flex gap-4 p-5 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-100 transition-all duration-300"
            >
              <div className="flex-shrink-0">
                <div className="w-11 h-11 rounded-full overflow-hidden bg-background-200">
                  <img src={cmt.avatar} alt={cmt.name} className="w-full h-full object-cover" loading="lazy" />
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                  <span className="text-sm font-semibold text-foreground-950 whitespace-nowrap">{cmt.name}</span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{cmt.time}</span>
                  <span className="px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
                    {cmt.show}
                  </span>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{cmt.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}